
(function() {
  'use strict';

  const DEBOUNCE_DELAY = 300;
  let debounceTimeout;

  function initFilters() {
    const desktopForm = document.querySelector('aside #collection-filters-form');
    const mobileForm = document.querySelector('.collection__filter-modal #collection-filters-form');

    if (!desktopForm) return;

    updateAppliedFiltersTags();
    initMobileFilterModal();
    window.addEventListener('popstate', handlePopState);

    // Listen for changes on both forms
    [desktopForm, mobileForm].forEach(form => {
      if (!form) return;

      // Prevent native form submit (causes full page reload on mobile)
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        if (form === desktopForm) handleProductFilterChange();
      });

      form.addEventListener('change', function(e) {
        const target = e.target;
        if (target.hasAttribute('data-collection-filter')) {
          handleCollectionFilterChange(target);
        } else if (target.hasAttribute('data-product-filter') || target.type === 'checkbox' || target.type === 'number') {
          // Only run filter update from desktop form; mobile modal waits for "APPLY FILTERS"
          if (form === desktopForm) {
            handleProductFilterChange();
          }
        }
      });

      form.querySelectorAll('input[type="number"]').forEach(input => {
        input.addEventListener('blur', handleProductFilterChange);
        input.addEventListener('keypress', e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleProductFilterChange();
          }
        });
      });
    });

    // Clear all buttons (desktop + mobile)
    // document.querySelectorAll('[data-clear-all-filters]').forEach(btn => {
    //   btn.addEventListener('click', handleClearAllFilters);
    // });
    // Clear all buttons (desktop + mobile) – works even if buttons are dynamically added
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-clear-all-filters]')) {
        handleClearAllFilters();
      }
    });


    // Remove individual tags (desktop & mobile)
    document.addEventListener('click', function(e) {
      const tag = e.target.closest('[data-filter-tag]');
      if (tag) {
        e.preventDefault();
        handleRemoveFilterTag(tag);
      }
    });
  }

  function handleCollectionFilterChange(checkbox) {
    document.querySelectorAll('[data-collection-filter]').forEach(cb => {
      if (cb !== checkbox) cb.checked = false;
    });

    const value = checkbox.value;
    if (value === 'all') {
      window.location.href = window.routes.allProductsCollection || '/collections/all';
    } else {
      window.location.href = `/collections/${value}`;
    }
  }

  function handleProductFilterChange() {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(submitFilters, DEBOUNCE_DELAY);
  }

  function submitFilters() {
    const desktopForm = document.querySelector('aside #collection-filters-form');
    if (!desktopForm) return;

    const formData = new FormData(desktopForm);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value) params.append(key, value);
    }

    const url = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    updateFilters(url);
  }

  function updateFilters(url, options) {
    const skipPushState = options && options.skipPushState;
    const productsContainer = document.querySelector('.collection__products');
    if (productsContainer) {
      productsContainer.style.opacity = '0.5';
      productsContainer.style.pointerEvents = 'none';
    }

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newProducts = doc.querySelector('.collection__products');
        if (productsContainer && newProducts) {
          productsContainer.innerHTML = newProducts.innerHTML;
          productsContainer.style.opacity = '1';
          productsContainer.style.pointerEvents = 'auto';
        }

        // Sync filter form checkboxes from the fetched page so they match the URL
        const desktopForm = document.querySelector('aside #collection-filters-form');
        const mobileForm = document.querySelector('.collection__filter-modal #collection-filters-form');
        const newDesktopForm = doc.querySelector('aside #collection-filters-form');
        const newMobileForm = doc.querySelector('.collection__filter-modal #collection-filters-form');
        if (desktopForm && newDesktopForm) desktopForm.innerHTML = newDesktopForm.innerHTML;
        if (mobileForm && newMobileForm) mobileForm.innerHTML = newMobileForm.innerHTML;

        // Update applied filters for both desktop and mobile
        ['desktop', 'mobile'].forEach(type => {
          const newContainer = doc.querySelector(`[data-applied-filters-container${type === 'mobile' ? '-mobile' : ''}]`);
          const container = document.querySelector(`[data-applied-filters-container${type === 'mobile' ? '-mobile' : ''}]`);
          if (container && newContainer) container.outerHTML = newContainer.outerHTML;
        });

        if (!skipPushState) window.history.pushState({}, '', url);
        updateAppliedFiltersTags();
      })
      .catch(() => window.location.href = url);
  }

  function handlePopState() {
    updateFilters(window.location.pathname + window.location.search, { skipPushState: true });
  }

  // function updateAppliedFiltersTags() {
  //   const desktopForm = document.querySelector('aside #collection-filters-form');
  //   const mobileForm = document.querySelector('.collection__filter-modal #collection-filters-form');

  //   // Prefer modal form if modal is open
  //   const modal = document.querySelector('.collection__filter-modal');
  //   const form = (modal && modal.classList.contains('is-open')) ? mobileForm : desktopForm;
  //   if (!form) return;

  //   const tagsContainer = document.querySelector(`[data-applied-tags]`);
  //   const container = document.querySelector(`[data-applied-filters-container]`);
  //   if (!tagsContainer || !container) return;

  //   const tags = [];

  //   // Collection filter
  //   const collectionCheckbox = form.querySelector('[data-collection-filter]:checked');
  //   const collectionValue = collectionCheckbox ? collectionCheckbox.value : 'all';
  //   const collectionLabel = collectionCheckbox
  //     ? collectionCheckbox.closest('label')?.querySelector('.collection__filter-label')?.textContent.trim() || collectionValue
  //     : 'All';
  //   tags.push({ type: 'collection', value: collectionValue, label: collectionLabel });

  //   // Product filters
  //   form.querySelectorAll('input[type="checkbox"][data-product-filter]:checked').forEach(cb => {
  //     const label = cb.closest('label')?.querySelector('.collection__filter-label');
  //     if (!label) return;
  //     tags.push({ type: 'shopify', value: cb.value, label: label.textContent.trim(), name: cb.name });
  //   });

  //   const closeSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false">
  //     <path d="M9 3L3 9M3 3L9 9" stroke="#001535" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  //   </svg>`;

  //   tagsContainer.innerHTML = tags.map(tag => `
  //     <button type="button" class="collection__filter-tag"
  //       data-filter-tag="${tag.type}" data-filter-value="${tag.value}" data-filter-name="${tag.name || ''}">
  //       ${tag.label} ${closeSVG}
  //       <span class="sr-only">Remove filter: ${tag.label}</span>
  //     </button>
  //   `).join('');

  //   container.style.display = tags.length > 1 || (tags.length === 1 && tags[0].value !== 'all') ? '' : 'none';
  // }

  function updateAppliedFiltersTags() {
    const desktopForm = document.querySelector('aside #collection-filters-form');
    const mobileForm = document.querySelector('.collection__filter-modal #collection-filters-form');

    // Prefer modal form if modal is open
    const modal = document.querySelector('.collection__filter-modal');
    const form = (modal && modal.classList.contains('is-open')) ? mobileForm : desktopForm;
    if (!form) return;

    const containers = document.querySelectorAll('[data-applied-filters-container]');
    if (!containers.length) return;

    const tags = [];

    // Collection filter
    const collectionCheckbox = form.querySelector('[data-collection-filter]:checked');
    if (collectionCheckbox) {
      const collectionLabel = collectionCheckbox.closest('label')?.querySelector('.collection__filter-label')?.textContent.trim() || collectionCheckbox.value;
      tags.push({ type: 'collection', value: collectionCheckbox.value, label: collectionLabel });
    }

    // Product filters
    form.querySelectorAll('input[type="checkbox"][data-product-filter]:checked').forEach(cb => {
      const label = cb.closest('label')?.querySelector('.collection__filter-label');
      if (!label) return;

      tags.push({
        type: 'shopify',
        value: cb.value,
        label: label.textContent.trim(),
        name: cb.name
      });
    });

    const closeSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false">
      <path d="M9 3L3 9M3 3L9 9" stroke="#001535" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    containers.forEach(container => {
      const tagsContainer = container.querySelector('[data-applied-tags]');
      if (!tagsContainer) return;

      tagsContainer.innerHTML = tags.map(tag => `
        <button type="button" class="collection__filter-tag"
          data-filter-tag="${tag.type}"
          data-filter-value="${tag.value}"
          data-filter-name="${tag.name || ''}">
          ${tag.label} ${closeSVG}
          <span class="sr-only">Remove filter: ${tag.label}</span>
        </button>
      `).join('');

      container.style.display = tags.length > 0 ? '' : 'none';
    });
  }






  function handleRemoveFilterTag(tag) {
    const type = tag.dataset.filterTag;
    const value = tag.dataset.filterValue;
    const name = tag.dataset.filterName;

    const forms = [
      document.querySelector('aside #collection-filters-form'),
      document.querySelector('.collection__filter-modal #collection-filters-form')
    ];

    forms.forEach(form => {
      if (!form) return;

      if (type === 'collection') {
        form.querySelectorAll('[data-collection-filter]').forEach(cb => cb.checked = false);
      } else if (type === 'shopify') {
        const checkbox = form.querySelector(`[data-product-filter][name="${name}"][value="${value}"]`);
        if (checkbox) checkbox.checked = false;
      }
    });

    if (type === 'collection') {
      window.location.href = window.routes?.allProductsCollection || '/collections/all';
    } else {
      handleProductFilterChange();
    }
  }

  function handleClearAllFilters() {
    const desktopForm = document.querySelector('aside #collection-filters-form');
    const mobileForm = document.querySelector('.collection__filter-modal #collection-filters-form');

    [desktopForm, mobileForm].forEach(form => {
      if (!form) return;
      form.querySelectorAll('input[type="checkbox"]').forEach(cb => cb.checked = false);
    });

    // Update tags immediately in both
    updateAppliedFiltersTags();

    // Trigger AJAX reload
    handleProductFilterChange();
  }


  function initMobileFilterModal() {
    const modal = document.querySelector('[data-mobile-filter-modal]');
    const trigger = document.querySelector('[data-mobile-filter-trigger]');
    const closeBtns = document.querySelectorAll('[data-mobile-filter-close]');
    const applyBtn = document.querySelector('[data-apply-mobile-filters]');

    if (!modal || !trigger || !applyBtn) return;

    trigger.addEventListener('click', () => {
      syncDesktopToModal();
      modal.classList.add('is-open');
      document.body.classList.add('collection-filter-modal-open');
    });

    closeBtns.forEach(btn => btn.addEventListener('click', () => {
      modal.classList.remove('is-open');
      document.body.classList.remove('collection-filter-modal-open');
    }));

    applyBtn.addEventListener('click', () => {
      syncModalToDesktop();
      modal.classList.remove('is-open');
      document.body.classList.remove('collection-filter-modal-open');
      handleProductFilterChange();
    });
  }

  function syncDesktopToModal() {
    const desktopForm = document.querySelector('aside #collection-filters-form');
    const modalForm = document.querySelector('.collection__filter-modal #collection-filters-form');
    if (!desktopForm || !modalForm) return;

    modalForm.querySelectorAll('input').forEach(input => {
      const desktopInput = desktopForm.querySelector(`input[name="${input.name}"][value="${input.value}"]`);
      if (!desktopInput) return;
      input.checked = desktopInput.checked;
      if (input.type === 'number') input.value = desktopInput.value;
    });
  }

  function syncModalToDesktop() {
    const desktopForm = document.querySelector('aside #collection-filters-form');
    const modalForm = document.querySelector('.collection__filter-modal #collection-filters-form');
    if (!desktopForm || !modalForm) return;

    modalForm.querySelectorAll('input').forEach(input => {
      const desktopInput = desktopForm.querySelector(`input[name="${input.name}"][value="${input.value}"]`);
      if (!desktopInput) return;
      desktopInput.checked = input.checked;
      if (input.type === 'number') desktopInput.value = input.value;
    });

    updateAppliedFiltersTags();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilters);
  } else {
    initFilters();
  }

  window.routes = window.routes || { allProductsCollection: '/collections/all' };
})();
